<button [type]="type" class="core-btn" [class.btn-primary]="variant === 'primary'"
    [class.btn-secondary]="variant === 'secondary'" [class.btn-danger]="variant === 'danger'" [class.w-full]="fullWidth"
    [disabled]="disabled" (click)="handleClick($event)">
    <fa-icon *ngIf="isLoading" [icon]="icons.fasCircleNotch" animation="spin" class="btn-loading-icon"
        aria-hidden="true"></fa-icon>
    {{ label }}
</button>